import { GET_ALL_USERS } from "../actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ALL_USERS: {
      const { users } = action.payload;
      return { ...state, users };
    }
    default:
      return state;
  }
};
